import React from 'react'
import { Field } from 'react-final-form'

import BubbleField from '../fields/bubble/bubble-field.component'

const TextualFields: React.FC = () => <Field name="importanceTextual" component={BubbleField} />

export default TextualFields
